import EcheckVoidModal from './EcheckVoidModal';
import { connect } from 'react-redux';

import { paymentsActions } from 'src/store/modules/payments';

const mapDispatchToProps = (dispatch: any) => ({
  voidEcheck: (databaseId: number, params: any) => {
    dispatch(paymentsActions.updatePayment(databaseId, params));
  }
});

export const pureComponent = EcheckVoidModal;

export default connect(null, mapDispatchToProps)(EcheckVoidModal);
